var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7773 18.7188C20.0898 19.0312 20.0898 19.5 19.7773 19.7812C19.6523 19.9375 19.4648 20 19.2773 20C19.0586 20 18.8711 19.9375 18.7148 19.7812L14.5273 15.5938C13.4023 16.5 11.9961 17 10.4961 17C6.93359 17 4.02734 14.0938 4.02734 10.5C4.02734 6.9375 6.90234 4 10.4961 4C14.0586 4 16.9961 6.9375 16.9961 10.5C16.9961 12.0312 16.4961 13.4375 15.5898 14.5312L19.7773 18.7188ZM5.52734 10.5C5.52734 13.2812 7.74609 15.5 10.5273 15.5C13.2773 15.5 15.5273 13.2812 15.5273 10.5C15.5273 7.75 13.2773 5.5 10.5273 5.5C7.74609 5.5 5.52734 7.75 5.52734 10.5Z",
    fill: "#1D1D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.fadce8c0.svg";
export { ForwardRef as ReactComponent };